import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';

class Offers extends Component {
  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }

  static contextTypes = {
    executeAction: React.PropTypes.func
  }

  render() {
    var offers = this.props.offers;
    var entity = this.props.entity[0];
    console.log(entity, offers);
    if(offers.length){
      return (
        <div className="container-fluid" style={ { "padding": "0em", "margin-top": "85px" } }>
          {offers.map(function(item){
            return(
              <div className="row result_card" style={{"padding": "1%"}}>
                <div className="col-md-2 col-sm-2 col-xs-2">
                  <img className="img img-responsive img-rounded result_thumb" height="150" width="150" src={entity.image} />
                </div>

                <div className="col-md-6 col-sm-6 col-xs-6 result_info">
                  <p style={{"font-size": "large","font-weight": "bold"}}>Offer name: {item.offer_name}</p>
                  <p>{entity.cuisines.replace(/\"/g,"").split(",").join(" | ")}</p>
                  <p>offer value: {item.offer_value}</p>
                </div>
              </div>
            );
          })}
        </div>
        );
    }
    else {
      return (
        <div className="container-fluid" style={ { "padding": "0em", "margin-top": "85px" } }>
          <div style={{"margin": "0 auto", "width": "250px", "margin-top": "100px"}}>
            <p style={{"font-size": "large"}}>User id/details unavailable</p>
          </div>
        </div>
      )
    }
  }
}

module.exports = Offers;



// WEBPACK FOOTER //
// ./src/components/Offers.js